/** Public canonical paths stay stable. Alternate spellings remain compatible. */
export const detailAliases = {
  template: 'shortcuts', templates: 'shortcuts', shortcut: 'shortcuts',
  category: 'categories', subcategory: 'subcategories',
  collection: 'collections', app: 'apps',
} as const;

export const pageAliases: Record<string, string> = {
  home: '/', template: '/shortcuts', templates: '/shortcuts', shortcut: '/shortcuts', search: '/shortcuts',
  category: '/categories', browse: '/categories', subcategory: '/categories', subcategories: '/categories',
  app: '/apps', collection: '/collections',
  finder: '/tools', 'ai-shortcut-finder': '/tools', tool: '/tools', workflow: '/tools', workflows: '/tools',
  favorites: '/', saved: '/', settings: '/', premium: '/', pro: '/', whatsnew: '/', 'whats-new': '/', new: '/',
};

export function canonicalLinkPath(path: string): string {
  const parts = path.split('?')[0].split('#')[0].split('/').filter(Boolean);
  if (parts.length === 1) return pageAliases[parts[0]] ?? '/' + parts[0];
  if (parts.length === 2) {
    if (['tool', 'tools', 'workflow', 'workflows'].includes(parts[0])) return '/tools';
    const section = detailAliases[parts[0] as keyof typeof detailAliases] ?? parts[0];
    return '/' + section + '/' + parts[1];
  }
  return '/' + parts.join('/');
}
